import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./checkout_booking_summary_preview.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
